import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, X, ChevronRight, Award } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import T from './T';

export const PeriodReportCycleNotification: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isVisible, setIsVisible] = useState(false);
  const [cycleType, setCycleType] = useState<'semanal' | 'mensal'>('semanal');

  useEffect(() => {
    if (!user) return;

    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 = Sunday
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
    const isLastDayOfMonth = today.getDate() === lastDayOfMonth;
    const isSunday = dayOfWeek === 0;

    if (isSunday || isLastDayOfMonth) {
      const todayStr = today.toISOString().split('T')[0];
      const dismissedKey = `libritui_report_dismissed_${todayStr}`;
      if (localStorage.getItem(dismissedKey) !== 'true') {
        setCycleType(isLastDayOfMonth ? 'mensal' : 'semanal');
        const timer = setTimeout(() => setIsVisible(true), 2500);
        return () => clearTimeout(timer);
      }
    }
  }, [user]);

  const handleDismiss = () => {
    setIsVisible(false);
    const todayStr = new Date().toISOString().split('T')[0];
    localStorage.setItem(`libritui_report_dismissed_${todayStr}`, 'true');
  };

  const handleOpenReport = () => {
    handleDismiss();
    navigate(`/reports?period=${cycleType === 'mensal' ? 'monthly' : 'weekly'}`);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-20 right-4 z-[9990] max-w-sm w-full bg-slate-900 border border-warn/40 text-white p-5 rounded-3xl shadow-[0_24px_60px_-24px_rgba(0,0,0,0.35)] animate-in slide-in-from-bottom-5 duration-500">
      <div className="flex justify-between items-start gap-3">
        <div className="flex items-center gap-3">
          <div className="p-2.5 bg-warn/20 text-warn rounded-2xl border border-warn/30">
            <Sparkles size={22} />
          </div>
          <div>
            <span className="text-[10px] font-normal uppercase font-mono tracking-[0.14em] text-warn">RETROSPECTIVA PRONTA</span>
            <h4 className="font-semibold text-sm text-white">Relatório {cycleType === 'mensal' ? 'Mensal' : 'Semanal'}</h4>
          </div>
        </div>

        <button 
          onClick={handleDismiss}
          className="p-1.5 hover:bg-slate-800 rounded-full text-slate-400 hover:text-white transition-colors cursor-pointer"
        >
          <X size={16} />
        </button>
      </div>

      <p className="text-xs font-medium text-slate-300 my-3 leading-relaxed">
        Parabéns pelos seus estudos! Seu relatório {cycleType} de evolução e Wrapped estão prontos para visualização.
      </p>

      <button 
        onClick={handleOpenReport}
        className="w-full py-3 bg-warn hover:bg-tint-butter text-ink font-normal text-xs uppercase font-mono tracking-[0.14em] rounded-xl flex items-center justify-center gap-2 transition-all hover:scale-[1.02] active:scale-95 cursor-pointer"
      >
        <span><T k="ui.report.view" /></span>
        <ChevronRight size={16} />
      </button>
    </div>
  );
};
